import PropTypes from 'prop-types';

const KeyIcon = ({ className }) => (
  <svg
    className={className}
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84 0H16C7.16344 0 0 7.16345 0 16V84C0 92.8366 7.16345 100 16 100H84C92.8366 100 100 92.8366 100 84V16C100 7.16344 92.8366 0 84 0Z"
      fill="#C9E3F7"
    />
    <path
      d="M39.3986 87.0001L30.124 77.7255L43.1084 64.7411L52.383 74.0157L39.3986 87.0001Z"
      fill="white"
    />
    <path
      d="M26.6667 84.6087L17.3922 75.3341L47.7045 45.0216L56.9791 54.2962L26.6667 84.6087Z"
      fill="#0A0777"
    />
    <path
      d="M51.4141 22.7625C59.0974 15.0792 71.5545 15.0792 79.2378 22.7625C86.9211 30.4458 86.9211 42.9029 79.2378 50.5862C71.5545 58.2695 59.0974 58.2695 51.4141 50.5862C43.7308 42.9029 43.7308 30.4458 51.4141 22.7625Z"
      fill="white"
    />
    <path
      d="M60.2168 31.8836C62.9504 29.15 67.3826 29.15 70.1163 31.8836C72.8499 34.6173 72.8499 39.0495 70.1163 41.7831C67.3826 44.5168 62.9504 44.5168 60.2168 41.7831C57.4831 39.0495 57.4831 34.6173 60.2168 31.8836Z"
      fill="#0A0777"
    />
  </svg>
);

KeyIcon.propTypes = {
  className: PropTypes.string
};

KeyIcon.defaultProps = {
  className: ''
};

export default KeyIcon;
